module.exports = __webpack_public_path__ + "img/left_icon_join_w.5f023b68.png";